import React, { useRef } from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { Button } from "reactstrap";
import badgeImg from "../../assets/img/custom/sportsCommunityBadgeDowmloadAble.png";

const DownloadBadge = ({ badgeNumber }) => {
  const badgeRef = useRef();
  const issuedDate = new Date()
    .toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    })
    .toUpperCase();

  const handleDownload = async () => {
    const canvas = await html2canvas(badgeRef.current, { scale: 2 });
    const imgData = canvas.toDataURL("image/png");

    const pdf = new jsPDF({
      orientation: "portrait",
      unit: "px",
      format: [canvas.width, canvas.height],
    });

    pdf.addImage(imgData, "PNG", 0, 0, canvas.width, canvas.height);
    pdf.save(`FHP_Badge_${badgeNumber}.pdf`);
  };

  return (
    <>
      <p className="text-center text-danger font-weight-500">
        Download it, if you move anywhere else than you must buy it again.
      </p>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "20px",
        }}
      >
        <div
          ref={badgeRef}
          style={{
            width: "228px",
            backgroundColor: "white",
            border: "1px solid #ccc",
            position: "relative",
            fontFamily: "sans-serif",
          }}
        >
          <div style={{ position: "relative" }}>
            <img
              src={badgeImg}
              alt="Badge"
              style={{
                width: "100%",
                height: "auto",
                display: "block",
              }}
            />
            <div
              style={{
                position: "absolute",
                top: "23px",
                left: "4%",
                color: "#000",
                fontWeight: "bold",
                fontSize: "16px",
                padding: "2px 8px",
                borderRadius: "5px",
              }}
            >
              Badge No: {badgeNumber}
            </div>
            <div
              style={{
                position: "absolute",
                bottom: "20px",
                left: "12%",
                color: "#000",
                fontSize: "16px",
                padding: "2px 8px",
                borderRadius: "5px",
                fontWeight: "900",
              }}
            >
              DATE: {issuedDate}
            </div>
          </div>
        </div>
      </div>
      <div className="d-flex justify-content-center mt-3">
        <Button color="success" onClick={handleDownload}>
          Download Badge
        </Button>
      </div>
    </>
  );
};

export default DownloadBadge;
